type moduleStyles = {
  [key: string]: string
}

export const getStyles = (
  stylesInline?: string,
  stylesModule?: moduleStyles
) => {
  const styles: string[] = []

  if (stylesInline && typeof stylesInline === "string") {
    stylesInline?.split(" ").map((e) => {
      styles.push(stylesModule ? `${stylesModule[e]}` : e)
    })
  }

  return styles
}
